<div class="container mt-5">
  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiError}}
  </div>
  }
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="creation_date">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let element"> {{element.creation_date | date:'HH:mm, dd MMM yyyy'}}</td>
    </ng-container>

    <ng-container matColumnDef="from_user_name">
      <th mat-header-cell *matHeaderCellDef>From</th>
      <td mat-cell *matCellDef="let element"><a
          routerLink="/user/{{element.from_user_socialuid}}">{{element.from_user_name}}</a></td>
    </ng-container>

    <ng-container matColumnDef="from_org_name">
      <th mat-header-cell *matHeaderCellDef>Of</th>
      <td mat-cell *matCellDef="let element"><a routerLink="/org/{{element.from_org_id}}">{{element.from_org_name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="body">
      <th mat-header-cell *matHeaderCellDef>Message</th>
      <td mat-cell *matCellDef="let element"> {{element.body}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element"><a (click)="deleteMessage(element.id)" href="javascript:void(0)">Delete</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of materials">
  </mat-paginator>
</div>